import React from 'react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm?: () => void;
  title: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  showConfirmButton?: boolean;
  showCancelButton?: boolean;
  children?: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  showConfirmButton = true,
  showCancelButton = true,
  children,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white text-gray-900 rounded-lg shadow-xl p-6 w-full max-w-2xl mx-auto">
        <h2 className="text-xl font-bold mb-4">{title}</h2>
        {children ? children : <p className="mb-6">{message}</p>}
        {!children && <div className="flex justify-end space-x-3">
          {showCancelButton && (
            <button
              onClick={onClose}
              className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400 transition"
            >
              {cancelText}
            </button>
          )}
          {showConfirmButton && onConfirm && (
            <button
              onClick={onConfirm}
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition"
            >
              {confirmText}
            </button>
          )}
          {/* Botão OK para mensagens sem ação (quando não tem showCancelButton nem onConfirm) */}
          {!showCancelButton && !onConfirm && (
            <button
              onClick={onClose}
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition"
            >
              OK
            </button>
          )}
        </div>}
      </div>
    </div>
  );
};

export default Modal;
